import React, { createElement } from 'react'
import  {Input} from 'components/common'
import {SimpleBanner} from './banner'
import user from './user'


export default class Login extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			username: '',
			password: ''
		};
	}

	doLogin() {
		const credentials = {
			username: this.state.username,
			password: this.state.password
		};
		if (!credentials.username || !credentials.password) {
			alert('tem de indicar o username e password');
			return false;
		}
		http.post(
			'/sessions/doLogin.json', {
				data: {credentials: btoa(JSON.stringify(credentials))}
			}, (response, success) => {
				if (success) {
					window.location = '/';
				}
			}
		);
		return false;
	}

	onKeyDown(e) {
		if (e.key === 'Enter' && e.shiftKey === false) {
			e.preventDefault();
			this.doLogin();
		}
	}

	renderLogin() {
		return (
			<div>
				<SimpleBanner title={__('socials_portal')} />
				<div className="mb-4" />
				<div className="container">
					<div className="row content justify-content-center">
						<div className="col-xs-12 col-sm-6">
							<div className="card login mb-3">
								<div className="card-header">
									<h5 className="mb-0">
										<span>{__('users_start_session')}</span>
									</h5>
								</div>
								<div className="card-body">
									<div className="input-group flex-nowrap mb-4">
										<div className="input-group-prepend">
											<span className="input-group-text"><em className="la la-user" /></span>
										</div>
										<Input
											placeholder={__('attrs_username')}
											model={this.state}
											name="username"
											classNameEl="form-control"
											autoFocus={true}
										/>
									</div>
									<div className="input-group flex-nowrap mb-4">
										<div className="input-group-prepend">
											<span className="input-group-text"><em className="la la-key" /></span>
										</div>
										<Input type="password"
											placeholder={__('attrs_password')}
											model={this.state}
											name='password'
											classNameEl="form-control"
											onKeyDown={this.onKeyDown.bind(this)}
										/>
									</div>
									<div className="actions float-left">
										<a href="#" onClick={() => window.history.back()} title={__('buttons_back')}>
											<em className="la la-undo" />
										</a>
										<a href="/users/recover.html">
											<em className="la la-unlock" />
											{__('users_recover_password')}
										</a>
										<a href="/users/recover.html?type=u">
											<em className="la la-unlock" />
											{__('users_recover_username')}
										</a>
									</div>
									<div className="btn-group float-right">
										<button type="submit" className="btn btn-primary" onClick={this.doLogin.bind(this)}>
											<em className="la la-sign-in" />
											<span>{__('buttons_enter')}</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderLogout() {
		return (
			<div className="text-center">
				<button className="btn btn-primary">sair</button>
			</div>
		);
	}

	render() {
		return user.isLoggedIn() ? this.renderLogout() : this.renderLogin();
	}
}
